// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2J42l","right":"Footer_right__2NXFo","buttons":"Footer_buttons__3OrlS"};